import React from 'react'
import './OrderPicker.css'

class OrderPicker extends React.Component {
  updateOrder(e) {
    console.log('New order: ', e.target.value )
    const newIndex = e.target.value - 1
    this.props.updateResultOrder(newIndex, this.props.searchIndex, this.props.resultIndex)
  }
  renderOptions(result, index) {
    console.log('Running renderOptions.')
    return (
      <option key={index} value={index + 1}>{index + 1}</option>
    )
  }
  render() {
    const currentIndex = this.props.resultIndex + 1
    return (
      <select value={currentIndex} onChange={(e) => this.updateOrder(e)} >
        {this.props.results.map(this.renderOptions)}
      </select>
    )
  }
}

export default OrderPicker


// WEBPACK FOOTER //
// ./src/components/OrderPicker.js